define('shared/util/dom/expression/Evaluator',['shared/lib/jsep', 'shared/lib/JSON3', 'shared/util/registers/DataProvider', 'shared/lib/RSVP'], 
function (jsep, JSON, DataProvider, RSVP) {
    'use strict';

    var TYPE_BINARY = 'BinaryExpression';
    var TYPE_CALL = 'CallExpression';
    var TYPE_ID = 'Identifier';
    var TYPE_LITERAL = 'Literal';
    var TYPE_UNARY = 'UnaryExpression';
    var TYPE_CONDITIONAL = 'ConditionalExpression';
    var TYPE_MEMBER = 'MemberExpression';
    var TYPE_LOGICAL = 'LogicalExpression';

    var OPERATOR_BINARY = ['*', '/', '+', '-', '>>', '<<', '>>>', '|', '&', '%', '==', '===', '>', '<', '>=', '<=', '!=', '!=='];
    var OPERATOR_UNARY = ['~', '!'];
    var operators = {};

    function createOperators(){
        var l, operator;
        for(l = OPERATOR_BINARY.length; l--;){
            operator = OPERATOR_BINARY[l];
            operators[operator] = 
                new Function('left', 'right', 'return left ' +  operator +  ' right');
        }

        for(l = OPERATOR_UNARY.length; l--;){
            operator = OPERATOR_UNARY[l];
            operators[operator] = 
                new Function('value', 'return ' +  operator +  'value');
        }
    }

    function pushToProviders(entity){
        var me = this;
        var providers = me.providers;

        for(var l = providers.length; l--;) {
            if ( providers[l] === entity ) {
                return;
            }
        }

        providers.push(entity);
    }

    createOperators();

    function iterate( node, context, holder) {
        var me = this;
        return RSVP.resolve()
        .then(function(){
            var argsPromise, args;

            function createRecursiveCall(node, args, index){
                return function () {
                    return iterate.call(me, node.arguments[index])
                        .then(function(arg) {
                            args.push(arg);
                        });
                };
            }

            if ( node.type == TYPE_LITERAL ) {
                return RSVP.resolve(node.value);
            }
            else if ( node.type == TYPE_CALL ) {
                holder = {};
                argsPromise = RSVP.resolve();
                args = [];
                if ( node.arguments.length > 0 ) {
                    for(var i = 0; i < node.arguments.length; i++) {
                        argsPromise = argsPromise.then(createRecursiveCall(node, args, i));
                    }
                }

                return argsPromise
                    .then(function(){
                        return iterate.call(me, node.callee, null, holder);
                    })
                    .then(function(callee){
                        return RSVP.resolve(callee.apply(holder.context || null, args));
                    });

            }
            else if ( node.type == TYPE_ID ) {

                if ( context ) {
                    if ( holder ) {
                        holder.context = context;
                    }
                    return RSVP.resolve(context[node.name]);
                }
                else {
                    return DataProvider.instance.get(node.name)
                        .then(function(entity){
                            pushToProviders.call(me, entity);
                            var value = entity.value();
                            return RSVP.resolve(value);
                        });
                }

            }
            else if ( node.type == TYPE_BINARY ) {

                return RSVP.resolve() 
                    .then(function(){
                        if ( node.left == null || node.right == null ) {
                            throw new Error('node corrupted');
                        }

                        return iterate.call(me, node.left);
                    })
                    .then(function(left){
                        return RSVP.all([left, iterate.call(me, node.right)]);
                    })
                    .then(function(values){
                        var left = values[0];
                        var right = values[1];
                        
                        var operation = operators[node.operator];

                        if ( operation == null ) {
                            throw new Error('Operation is not supported');
                        }

                        return RSVP.resolve(operation(left, right));
                    });

            }
            else if ( node.type == TYPE_CONDITIONAL ) {
                return iterate.call(me, node.test)
                    .then(function(result){
                        if ( result ) {
                            return iterate.call(me, node.consequent);
                        }
                        else {
                            return iterate.call(me, node.alternate);
                        }
                    });
            }
            else if ( node.type == TYPE_UNARY ) {
                if ( node.argument == null ) {
                    throw new Error('Unary operation does not have arugment');
                }

                return iterate.call(me, node.argument)
                    .then(function(value){
                        return RSVP.resolve(operators[node.operator](value));
                    });
            }
            else if ( node.type == TYPE_MEMBER ) {
                return iterate.call(me, node.object)
                    .then(function(object){
                        if ( node.computed === true ) {
                            var parent, member;
                            return iterate.call(me, node.property)
                                .then(function(value){
                                    member = value;
                                    return iterate.call(me, node.object);
                                })
                                .then(function(value){
                                    parent = value;
                                    return RSVP.resolve(parent[member]);
                                });
                        }
                        else {
                            if (object == null) {
                                throw new Error('Trying to access ' + 
                                    (node.property && node.property.name) + 
                                    ' of ' + typeof object);
                            }
                            return iterate.call(me, node.property, object, holder);
                        }
                    });
            }
            else if ( node.type == TYPE_LOGICAL ) {
                return iterate.call(me, node.left)
                    .then(function(left){
                        if (node.operator === '&&') {
                            if (!left) {
                                return RSVP.resolve(left);
                            }
                            else {
                                return iterate.call(me, node.right);
                            }
                        }
                        else if(node.operator === '||'){
                            if (left) {
                                return RSVP.resolve(left);
                            }
                            else {
                                return iterate.call(me, node.right);
                            }
                        }
                        else {
                            throw new Error('LogicalExpression operator not supported: ' + node.operator);
                        }
                    });
            }
            else {
                throw new Error('Type not supported: ' + node.type);
            }
        });
    }

    function Ctor(){
        var me = this;
        me.providers = [];
    }

    var p = Ctor.prototype;

    p.evaluate = function( expression ){
        var me = this;
        var ast = jsep(expression.replace(/[\n\r]/g, ' '));
        
        return iterate.call(me, ast)
            .then(null, function(x){
                return RSVP.reject(x + ', from expression ' + expression);
            });
    };

    return Ctor;
});
